// AI ALLOWLIST RETIRED (C2-U6a1b, QJ ruling board #230/#212 2026-07-09: "AI works for EVERY
// user" -- supersedes the old per-environment userId allowlist). The dev-shim branch below
// (unconditional localStorage/?ai= toggle, default ON) is now the body for every build, not just
// the dev shim -- the QJ-gated staging/prod promotion steps ARE the exposure control from here
// on, and the kill-switch below covers any emergency need to turn AI off without a rebuild.
export const showAiFeature = (userId: number) => {
  try {
    return window.localStorage.getItem("coowe.aiEnabled") !== "false"
  } catch {
    return true
  }
}
